import moment from "moment";

export const PartOrderTypes = [
    "P",
    "F",
] as const;

export type PartOrderType = typeof PartOrderTypes[number];

export const PartOrderTypeLabels = {
    P: "Pièce",
    F: "Filtre à eau",
} as const;

export const PartOrderLangs = [
    "fr",
    "en",
] as const;

export type PartOrderLang = typeof PartOrderLangs[number];

export const PartOrderLangLabels = {
    fr: "Français",
    en: "Anglais",
} as const;

export interface PartOrder {
    id: string;
    order_num: string;
    phone_no: string;
    sell_date: moment.Moment;
    last_call_date?: moment.Moment;
    date_received?: moment.Moment;
    confirmed: boolean;
    confirmed_at_date?: moment.Moment;
    type: PartOrderType;
    lang: PartOrderLang;
    call_try_interval_hours: number;
    part_lifetime_months?: number;
}
